import type { Quiz, TileMatchPlayStart, TileMatchRoundDto, TileMatchTileDto } from '../services/api';
import { TILE_MATCH_TOTAL_ROUNDS } from './tileMatchPlayScoring';

export function isTileMatchQuizFormat(quiz: Quiz | null | undefined): boolean {
  const f = (quiz?.format ?? '').toString();
  return f === 'TileMatch' || f === 'tileMatch' || f === 'tilematch';
}

export function parseTileMatchPlayStart(raw: unknown): TileMatchPlayStart | null {
  if (!raw || typeof raw !== 'object') return null;
  const o = raw as Record<string, unknown>;
  const playSessionId = String(o.playSessionId ?? o.PlaySessionId ?? '').trim();
  if (!playSessionId) return null;

  const imageAssetsBasePath = String(
    o.imageAssetsBasePath ?? o.ImageAssetsBasePath ?? ''
  ).trim();

  const roundRaw = o.round ?? o.Round;
  const round = roundRaw ? parseTileMatchRound(roundRaw) : undefined;

  return {
    playSessionId,
    imageAssetsBasePath,
    round,
    totalRounds: Number(o.totalRounds ?? o.TotalRounds ?? TILE_MATCH_TOTAL_ROUNDS) || TILE_MATCH_TOTAL_ROUNDS,
    engineBootstrapCipher: o.engineBootstrapCipher != null ? String(o.engineBootstrapCipher) : o.EngineBootstrapCipher != null ? String(o.EngineBootstrapCipher) : undefined,
  };
}

export function parseTileMatchRound(raw: unknown): TileMatchRoundDto | null {
  if (!raw || typeof raw !== 'object') return null;
  const o = raw as Record<string, unknown>;
  const roundIndex = Number(o.roundIndex ?? o.RoundIndex ?? 0);
  if (!Number.isFinite(roundIndex) || roundIndex < 1) return null;

  const tilesRaw = o.tiles ?? o.Tiles;
  const tiles = Array.isArray(tilesRaw)
    ? tilesRaw.map(parseTile).filter((t): t is TileMatchTileDto => t != null)
    : [];

  return {
    roundIndex,
    tiles,
    distinctKeyCount: Number(o.distinctKeyCount ?? o.DistinctKeyCount ?? 0),
    triosPerKey: Number(o.triosPerKey ?? o.TriosPerKey ?? 0),
    totalTiles: Number(o.totalTiles ?? o.TotalTiles ?? 0),
    maxLayers: Number(o.maxLayers ?? o.MaxLayers ?? 0),
  };
}

export function parseTile(raw: unknown): TileMatchTileDto | null {
  if (!raw || typeof raw !== 'object') return null;
  const o = raw as Record<string, unknown>;
  const id = String(o.id ?? o.Id ?? '').trim();
  const imageAssetKey = String(o.imageAssetKey ?? o.ImageAssetKey ?? '').trim();
  if (!id || !imageAssetKey) return null;
  return {
    id,
    imageAssetKey,
    questionId: o.questionId != null ? String(o.questionId) : o.QuestionId != null ? String(o.QuestionId) : undefined,
    x: Number(o.x ?? o.X ?? 0),
    y: Number(o.y ?? o.Y ?? 0),
    z: Number(o.z ?? o.Z ?? 0),
    isBlocked: Boolean(o.isBlocked ?? o.IsBlocked ?? false),
  };
}
